export const SUPPORTED_LOCALES = ['en', 'pt', 'es'] as const;

export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: AppLocale = 'en';

export const LOCALE_STORAGE_KEY = 'aplus_locale';

export const LOCALE_LABELS: Record<AppLocale, string> = {
  en: 'English',
  pt: 'Português',
  es: 'Español',
};

export function isAppLocale(value: string | null | undefined): value is AppLocale {
  return SUPPORTED_LOCALES.includes(value as AppLocale);
}

export function resolveLocale(value: string | null | undefined): AppLocale {
  if (isAppLocale(value)) {
    return value;
  }

  const browserLocale = typeof navigator !== 'undefined'
    ? navigator.language.split('-')[0]
    : DEFAULT_LOCALE;

  return isAppLocale(browserLocale) ? browserLocale : DEFAULT_LOCALE;
}
